import { render, staticRenderFns } from "./SuperMenu.vue?vue&type=template&id=08abf160&scoped=true"
import script from "./SuperMenu.vue?vue&type=script&lang=js"
export * from "./SuperMenu.vue?vue&type=script&lang=js"
import style0 from "./SuperMenu.vue?vue&type=style&index=0&id=08abf160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08abf160",
  null
  
)

export default component.exports